import { t } from './i18n.js';

$(document).ready(function() {
    // Initialize datepickers on poll creation/edit page
    if (typeof window.handleDatepickers === 'function') {
        window.handleDatepickers();
    }
    
    // Poll creation functionality
    let $pollOptions = $('#poll-options-repeater');
    let $addButton = $('[data-repeater-create]');

    // Initialize options
    let optionIndex = 0;

    if ($pollOptions.length > 0) {
        if (typeof $pollOptions.repeater !== 'function') {
            console.error('Repeater function not available! jQuery repeater library not loaded.');
            return;
        }
        
        // Simple implementation instead of repeater
        function createNewOption(index) {
            return `
                <div class="my-2 poll-option-item d-flex">
                    <div class="d-flex flex-column text-center px-2">
                        <div class="list-move-up" title="${t('tableReorderTitle')}"><i class="mdi mdi-chevron-up"></i></div>
                        <div class="list-move-down" title="${t('tableReorderTitle')}"><i class="mdi mdi-chevron-down"></i></div>
                    </div>
                    <div class="center w-100 pt-2">
                        <input type="text" class="form-control poll-option-text-input" name="options[${index}][text]" value="" placeholder="${t('addAnswerPlaceholder')}">
                        <input type="hidden" class="poll-option-order-input" name="options[${index}][order]" value="${index + 1}">
                        <input type="hidden" class="poll-option-template" name="options[${index}][template]" value="">
                        <input type="hidden" class="poll-option-existing" name="options[${index}][existing]" value="">
                    </div>
                    <div class="flex-end text-center pt-2 px-2">
                        <span class="option-delete">
                          <span class="mdi mdi-close-circle repeater-delete"></span>
                        </span>
                    </div>
                </div>
            `;
        }
        
        // Remove any template elements
        $('#poll-options .poll-option-item.template').remove();
        
        // Check if we need to create first option
        const finalOptionsCount = $('#poll-options .poll-option-item').length;
        
        if (finalOptionsCount === 0) {
            $('#poll-options').html(createNewOption(optionIndex));
            optionIndex++;
        } else {
            optionIndex = finalOptionsCount;
        }
        
        // Restore form data after validation errors
        restoreFormData();
        
        // Initialize existing options readonly state
        initializeExistingOptionsState();
        
        // Initial validation
        toggleAddButton();
        
        // Handle add button clicks
        $addButton.click(function(e) {
            e.preventDefault();
            
            if ($(this).hasClass('disabled')) {
                return false;
            }
            
            const newOption = createNewOption(optionIndex);
            $('#poll-options').append(newOption);
            optionIndex++;
            
            setPollOptionsOrder();
            initializeExistingOptionsState(); // Re-initialize after adding
            toggleAddButton();
            
            // Focus on new input
            $('#poll-options .poll-option-item').last().find('.poll-option-text-input').focus();
        });
        
        // Handle delete option
        $(document).on('click', '.option-delete', function() {
            const $allOptions = $('#poll-options .poll-option-item');
            if ($allOptions.length <= 1) {
                return;
            }
            
            $(this).closest('.poll-option-item').remove();
            setPollOptionsOrder();
            initializeExistingOptionsState(); // Re-initialize after deletion
            toggleAddButton();
        });

        // Handle send to all checkbox functionality
        function toggleRecipientSelection() {
            const sendToAll = $('#id_send_to_all').is(':checked');
            const recipientsGroup = $('.recipients-choice');
            
            if (sendToAll) {
                recipientsGroup.hide();
                $('#id_recipients').prop('required', false);
            } else {
                recipientsGroup.show();
                $('#id_recipients').prop('required', true);
            }
        }
        
        // Initialize visibility
        toggleRecipientSelection();
        
        // Handle checkbox changes
        $('#id_send_to_all').change(function() {
            toggleRecipientSelection();
        });

        // Handle option reordering
        $(document).on('click', '.list-move-up', function(e) {
            let $wrapper = $(this).closest('.poll-option-item');
            let $prev = $wrapper.prev('.poll-option-item');
            if ($prev.length) {
                $wrapper.fadeOut(200, () => {
                    $wrapper.insertBefore($prev);
                    setPollOptionsOrder();
                    initializeExistingOptionsState(); // Re-initialize after reordering
                    $wrapper.fadeIn(200);
                });
            }
        });
        
        $(document).on('click', '.list-move-down', function(e) {
            let $wrapper = $(this).closest('.poll-option-item');
            let $next = $wrapper.next('.poll-option-item');
            if ($next.length) {
                $wrapper.fadeOut(200, () => {
                    $wrapper.insertAfter($next);
                    setPollOptionsOrder();
                    initializeExistingOptionsState(); // Re-initialize after reordering
                    $wrapper.fadeIn(200);
                });
            }
        });

        // Handle input changes to toggle add button
        $(document).on('input', '.poll-option-text-input', function() {
            toggleAddButton();
        });
        
        // Enter key acts as "Add option" button
        $(document).on('keydown', '.poll-option-text-input', function(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                
                // If current field has content, trigger "Add option" button
                if ($(this).val().trim() !== '') {
                    $('[data-repeater-create]').trigger('click');
                    // Small delay to ensure new item is created before focusing
                    setTimeout(function() {
                        $('#poll-options .poll-option-item:not(.template)').last().find('.poll-option-text-input').focus();
                    }, 100);
                } else {
                    // If empty, just move to next existing option or do nothing
                    const $currentItem = $(this).closest('.poll-option-item');
                    const $nextItem = $currentItem.next('.poll-option-item:not(.template)');
                    
                    if ($nextItem.length > 0) {
                        $nextItem.find('.poll-option-text-input').focus();
                    }
                }
                
                return false;
            }
        });
    }

    // Function to initialize readonly state for existing options
    function initializeExistingOptionsState() {
        $('#poll-options .poll-option-item').each(function() {
            const $item = $(this);
            const $textInput = $item.find('.poll-option-text-input');
            const $existingInput = $item.find('input[name*="[existing]"]');
            const isExisting = $existingInput.val() === 'true';
            
            if (isExisting) {
                // Make readonly and add visual indicators
                $textInput.prop('readonly', true);
                $textInput.attr('title', t('tableExistingOptionReadonlyTitle'));
                $item.addClass('existing-option');
                
                // Add visual indicator if not present
                if (!$item.find('.text-muted').length) {
                    const $indicator = $(`<small class="text-muted"><i class="mdi mdi-lock"></i> ${t('tableExistingOptionHint')}</small>`);
                    $textInput.after($indicator);
                }
            } else {
                // Make sure new options are editable
                $textInput.prop('readonly', false);
                $textInput.removeAttr('title');
                $item.removeClass('existing-option');
            }
        });
    }

    // Function to restore form data after errors
    function restoreFormData() {
        const existingOptions = $('#poll-options .poll-option-item');
        
        if (existingOptions.length > 0) {
            optionIndex = existingOptions.length;
            return;
        }
        
        // Fallback - check for hidden inputs
        const existingInputs = $('input[name*="options["][name*="][text]"]');
        
        if (existingInputs.length > 0) {
            $('#poll-options').empty();
            let maxIndex = 0;
            
            existingInputs.each(function(i) {
                const value = $(this).val();
                const match = $(this).attr('name').match(/options\[(\d+)\]/);
                if (match) {
                    const index = parseInt(match[1]);
                    maxIndex = Math.max(maxIndex, index);
                    
                    const optionHtml = createNewOption(index);
                    $('#poll-options').append(optionHtml);
                    
                    $(`#poll-options .poll-option-item:last .poll-option-text-input`).val(value);
                }
            });
            
            optionIndex = maxIndex + 1;
        }
    }

    function setPollOptionsOrder() {
        const $allOptions = $('#poll-options .poll-option-item');
        
        $allOptions.each((i, element) => {
            const $element = $(element);
            const $orderInput = $element.find('input[name*="[order]"]');
            const $textInput = $element.find('input[name*="[text]"]');
            const $idInput = $element.find('input[name*="[id]"]');
            const $existingInput = $element.find('input[name*="[existing]"]');
            const $templateInput = $element.find('input[name*="[template]"]');
            
            // Update all field names to maintain consistency
            $textInput.attr('name', `options[${i}][text]`);
            $orderInput.attr('name', `options[${i}][order]`).val(i + 1);
            
            if ($idInput.length > 0) {
                $idInput.attr('name', `options[${i}][id]`);
            }
            if ($existingInput.length > 0) {
                $existingInput.attr('name', `options[${i}][existing]`);
            }
            if ($templateInput.length > 0) {
                $templateInput.attr('name', `options[${i}][template]`);
            }
        });
    }

    function toggleAddButton() {
        let $addButton = $('[data-repeater-create]');
        let emptyOptionLeft = false;
        
        const $allOptions = $('#poll-options .poll-option-item:visible:not(.template)');
        
        $allOptions.each(function(i) {
            let $item = $(this);
            let $textInput = $item.find('.poll-option-text-input');
            if ($textInput.length > 0) {
                let value = $textInput.val() || '';
                if (value.trim() === '') {
                    emptyOptionLeft = true;
                    return false;
                }
            }
        });
        
        if (emptyOptionLeft) {
            $addButton.addClass('disabled');
        } else {
            $addButton.removeClass('disabled');
        }
    }
});
